import "./Content.scss";
import { useData } from "../../hooks/useData"

export function Content() {
  const { orientation } = useData()

  return (
    <div className={`content ${orientation}`}>
      <p> O “Concurso de desenhos” é realizado pela Fundação Japão desde 1999 e tem como público-alvo, alunos que estudam a língua japonesa nas escolas de ensino fundamental e médio.</p>

      <p>No concurso de 2025, houve a participação de 1405 alunos.</p>

      <div className="title">
        O tema é: “Um mergulho nas obras literárias japonesas”
      </div>
    </div>
  )
}